import { useState } from "react";
import { uploadBytesResumable, getDownloadURL } from "firebase/storage";

export const useUploadWithProgress = () => {
  const [progress, setProgress] = useState(0);

  const uploadFileWithProgress = async (storageRef, file) => {
    setProgress(0);
    return new Promise((resolve, reject) => {
      const uploadTask = uploadBytesResumable(storageRef, file);

      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const pct = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          setProgress(Math.round(pct));
        },
        (error) => {
          setProgress(0);
          reject(error);
        },
        async () => {
          try {
            const url = await getDownloadURL(uploadTask.snapshot.ref);
            setProgress(100);
            resolve(url);
          } catch (error) {
            setProgress(0);
            reject(error);
          }
        }
      );
    });
  };

  return { uploadFileWithProgress, progress };
};
